import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, ClipboardList, Wrench, AlertTriangle, User, CalendarClock } from 'lucide-react';

const MobileNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { path: '/mobile', icon: Home, label: 'Home' },
    { path: '/mobile/work-orders', icon: ClipboardList, label: 'Work' },
    { path: '/mobile/services', icon: CalendarClock, label: 'Service' },
    { path: '/mobile/inspections', icon: Wrench, label: 'Inspect' },
    { path: '/mobile/defects', icon: AlertTriangle, label: 'Defects' },
    { path: '/mobile/profile', icon: User, label: 'Profile' },
  ];

  const isActive = (path) => {
    if (path === '/mobile') {
      return location.pathname === '/mobile';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 bg-[var(--surface-card)] border-t border-[var(--border)] px-2 py-1 z-50 safe-area-bottom"
      style={{ boxShadow: 'var(--elev-floating)' }}
    >
      <div className="flex justify-around items-center max-w-lg mx-auto">
        {navItems.map(({ path, icon: Icon, label }) => {
          const active = isActive(path);
          return (
            <button
              key={path}
              onClick={() => navigate(path)}
              className={`flex flex-col items-center py-1.5 px-3 rounded-[12px] transition-colors min-w-[60px] ${
                active
                  ? 'bg-[var(--volt-tint)] text-[var(--volt-ink)]'
                  : 'text-[var(--ink-tertiary)] hover:text-[var(--ink-secondary)]'
              }`}
            >
              <Icon className={`w-5 h-5 ${active ? 'stroke-[2.5]' : ''}`} />
              <span className="text-[10px] mt-1 font-medium">{label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNav;
